<template>
  <div
    class="einvoice-vat-sheet"
    :class="{
      'einvoice-vat-sheet--preview': previewMode,
      'einvoice-vat-sheet--detail': detailMode,
    }"
  >
    <div class="einvoice-vat-sheet__main">
      <EInvoiceGoodsTable
        :items="items"
        :show-product-image="showProductImage"
        :show-item-code="showItemCode"
        :max-height="goodsTableMaxHeight"
        :sticky-head="previewMode"
      />
    </div>

    <div class="einvoice-vat-sheet__footer">
      <div class="einvoice-vat-sheet__tax">
        <EInvoiceTaxBreakdownTable :rows="summary.taxBreakdown || []" />
      </div>

      <div class="einvoice-vat-sheet__summary">
        <EInvoiceSummaryTable
          :summary="summary"
          :emphasize-total="emphasizeSummaryTotal"
          :amount-in-words-text="amountInWordsText"
          :amount-in-words-class="amountInWordsClass"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import EInvoiceGoodsTable from './EInvoiceGoodsTable.vue'
  import EInvoiceTaxBreakdownTable from './EInvoiceTaxBreakdownTable.vue'
  import EInvoiceSummaryTable from './EInvoiceSummaryTable.vue'

  export default {
    name: 'EInvoiceVatTables',

    components: {
      EInvoiceGoodsTable,
      EInvoiceTaxBreakdownTable,
      EInvoiceSummaryTable,
    },

    props: {
      items: {
        type: Array,
        default: () => [],
      },
      summary: {
        type: Object,
        default: () => ({}),
      },
      previewMode: {
        type: Boolean,
        default: false,
      },
      detailMode: {
        type: Boolean,
        default: false,
      },
      goodsTableMaxHeight: {
        type: [Number, String],
        default: null,
      },
      showProductImage: {
        type: Boolean,
        default: false,
      },
      showItemCode: {
        type: Boolean,
        default: false,
      },
      emphasizeSummaryTotal: {
        type: Boolean,
        default: true,
      },
      amountInWordsText: {
        type: String,
        default: '',
      },
      amountInWordsClass: {
        type: [String, Array, Object],
        default: '',
      },
    },
  }
</script>

<style lang="scss" scoped>
  .einvoice-vat-sheet {
    // border: 1px solid #d8e0ea;
    // border-radius: 0.8rem;
    // background: #fff;
    overflow: hidden;
  }

  .einvoice-vat-sheet__main {
    min-width: 0;
    padding: 0.9rem 0.95rem 0;
  }

  .einvoice-vat-sheet__footer {
    display: flex;
    align-items: stretch;
    gap: 0.9rem;
    padding: 0.9rem 0.95rem 1rem;
    background: #fbfdff;
  }

  .einvoice-vat-sheet__tax {
    width: 38%;
    min-width: 320px;
  }

  .einvoice-vat-sheet__summary {
    width: 62%;
    min-width: 0;
  }

  .einvoice-vat-sheet--preview {
    border-radius: 0.5rem;

    .einvoice-vat-sheet__main {
      padding: 0.8rem 0.85rem 0;
    }

    .einvoice-vat-sheet__footer {
      gap: 0.8rem;
      padding: 0.8rem 0.85rem 0.9rem;
      font-size: 0.96em;
    }
  }

  .einvoice-vat-sheet--detail {
    border-color: #dde4ec;
    border-radius: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: 0;
    background: transparent;

    .einvoice-vat-sheet__main {
      padding: 0.9rem 0 0;
    }

    .einvoice-vat-sheet__footer {
      gap: 0.9rem;
      padding: 0.9rem 0 0;
      background: transparent;
    }
  }

  @media (max-width: 1199.98px) {
    .einvoice-vat-sheet__footer {
      flex-direction: column;
      gap: 0.75rem;
    }

    .einvoice-vat-sheet__tax,
    .einvoice-vat-sheet__summary {
      width: 100%;
      min-width: 0;
    }
  }
</style>
